import { Component, input } from '@angular/core';
import { getUaDevice } from '@context/frontend/native/platform';
import { TuiSizeL, TuiSizeS } from '@taiga-ui/core';

@Component({
	selector: 'ctx-page-card',
	styleUrl: 'page-card.component.scss',
	template: `<ng-content />`,
	host: {
		'[attr.device]': 'device',
		'[attr.size]': 'size()',
	},
})
export class PageCardComponent {
	readonly device = getUaDevice();

	readonly size = input<TuiSizeL | TuiSizeS | 'full'>('l');
}
